package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.SoundRepository

/**
 * Use case for deleting a user-uploaded sound.
 */
class DeleteSoundUseCase(
    private val soundRepository: SoundRepository
) {
    /**
     * Deletes a user-uploaded sound.
     * @param soundId The ID of the sound to delete
     * @param userId The ID of the user (for authorization)
     * @return Result indicating success or failure
     */
    suspend operator fun invoke(
        soundId: String,
        userId: String
    ): Result<Unit> {
        return soundRepository.deleteSound(soundId, userId)
    }
}
